import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { TableFactoryRowModel, TableFactoryStoreParams } from 'stores/common';
import { TableCellController } from 'stores/common/TableController';

import { CellErrorsTooltip } from './CellErrorsTooltip';
import CommentsButton from './CommentsButton';
import s from './ControllerCellFactory.module.scss';
import { CONTROLLER_COMPONENTS } from './controllers';

type Props = {
  record: TableCellController;
  row?: TableFactoryRowModel;
  tableParams: TableFactoryStoreParams;
};

const ControllersCellFactory: React.FC<Props> = ({ record, row }) => {
  const Component = CONTROLLER_COMPONENTS[record?.params.controllerKind];

  if (!Component || !row) {
    return null;
  }

  return (
    <div className={s.controllerCellFactory}>
      <Component params={record.params} row={row} record={record.controller} />
      <CommentsButton row={row} record={record} />
      {record.errors && (
        <CellErrorsTooltip errors={record.errors} />
      )}
    </div>
  );
};

export default observer(ControllersCellFactory);
